import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import classnames from 'classnames';

const SidebarSummary = ({ styles, items, header }) => {
  const headerClassNames = classnames(styles.SidebarSummary, styles.header);
  const itemClassNames = classnames(styles.SidebarSummary, styles.items);
  return (
    <div className={styles.SidebarSummaryContainer} data-cy="sidebar-summary">
      <div className={headerClassNames} data-cy="sidebar-summary-header"><span>{header}</span></div>
      <div className={itemClassNames} data-cy="sidebar-summary-items">
        {items.map((item) => {
          return(
            <div key={item}>{item}</div>
          );
        })}
      </div>
    </div>
  );
};

SidebarSummary.propTypes = {
  styles: PropTypes.object.isRequired,
  items: PropTypes.node,
  header: PropTypes.node
};

export default themeable(SidebarSummary);
